import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  width: 100%;
  background: ${Colors.background_secondary};
  border-radius: 6px;
  padding-top: 17px;
  max-width: 100vw;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  margin-bottom: 36px;
  overflow: hidden;
  // @media (max-width: 768px) {
  //   overflow-x: scroll;
  // }
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.01em;
  background: ${Colors.BG_Header_Card};
  color: ${Colors.text_on_primary};
  margin: -17px 0px 0px 0px;
  padding-left: 17px;
  height: 42px;
  display: flex;
  align-items: center;
`;

const TableContainer = styled.div`
  display: grid;
  grid-template-columns: 36fr 23fr 24fr 17fr;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
  overflow-x: auto;
  @media (max-width: 768px) {
    min-width: 768px;
  }
`;

const TableCell = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const InsideCell = styled.div`
  display: flex;
  flex-direction: row;
`;

const ImageContainer = styled.img`
  border-radius: 5px;
  height: 34px;
  width: 34px;
  margin-right: 11px;
  min-width: 34px;
`;

const Line = styled.div`
  grid-column-start: 1;
  grid-column-end: ${(props) => `${props.columns + 1}`};
  height: 1px;
  border-bottom: 1px solid ${Colors.line_separator};
  width: 100%;
`;

const NoItemsContainer = styled.div`
  height: 144px;
  display: grid;
  align-items: center;
`;

const NoItemsMessageCenter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${Colors.text_secondary};
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
`;

export default {
  Container,
  Title,
  TableContainer,
  TableCell,
  ImageContainer,
  Line,
  NoItemsContainer,
  NoItemsMessageCenter,
  InsideCell,
};
